import React from "react";
import {Row} from "react-bootstrap";
import {Input, InputCPF, RadioGroup} from "../../../genericComponents";
import {pensionFormNames} from "../models/pensionFormNames";
import {required} from "../models/required";
import {defaultTwoOptions} from "../models/selects";

function PensionRegister11({serverData}) {
  const [hasDependentsUnder18, setHasDependentsUnder18] = React.useState(null);
  const [childrenHasBenefits, setChildrenHasBenefits] = React.useState(null);
  const serverHasDependentsUnder18 = serverData?.hasDependentsUnder18;
  const serverChildrenHasBenefits = serverData?.childrenHasBenefits;

  console.log(serverData)

  React.useEffect(() => {
    if (serverHasDependentsUnder18 === defaultTwoOptions[0]) setHasDependentsUnder18(true);
    if (serverChildrenHasBenefits === defaultTwoOptions[0]) setChildrenHasBenefits(true);
  }, [serverHasDependentsUnder18, setHasDependentsUnder18, serverChildrenHasBenefits, setChildrenHasBenefits]);

  const label = serverData?.hasDependentsUnder18CPF
    ? "A pessoa falecida tinha outros dependentes menores que 18 anos?"
    : "Deixou filhos menores de 21 anos?"
  return (
    <>
      <Row>
        <RadioGroup
          label={label}
          name={pensionFormNames.hasDependentsUnder18}
          options={defaultTwoOptions.map((item) => ({
            label: item,
            value: item,
          }))}
          required={required.default}
          inline
          onChange={(event, value) => {
            setHasDependentsUnder18(value === defaultTwoOptions[0]);
          }}
        />
      </Row>
      {hasDependentsUnder18 === true && (
        (serverData?.hasDependentsUnder18CPF ? (
          <Row>
            <InputCPF
              label="CPF"
              name={pensionFormNames.hasDependentsUnder18CPF}
              maxLength={100}
              required="O campo não deve ser vazio e deve conter um CPF válido."
            />
          </Row>
        ) : (
          <>
            <Row>
              <RadioGroup
                label="Algum dos filhos recebe benefício do governo (Ex.: BPC - LOAS)?"
                name={pensionFormNames.childrenHasBenefits}
                options={defaultTwoOptions.map((item) => ({
                  label: item,
                  value: item,
                }))}
                required={required.default}
                inline
                onChange={(event, value) => {
                  setChildrenHasBenefits(value === defaultTwoOptions[0]);
                }}
              />
            </Row>
            {childrenHasBenefits && (
              <Row>
                <Input
                  label="Indique o nome dele(s):"
                  name={pensionFormNames.childrenHasBenefitsNames}
                  maxLength={255}
                  required="O campo não deve ser vazio."
                />
              </Row>
            )}
          </>
        ))
      )}
    </>
  );
}

export default React.memo(PensionRegister11);
